import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateEventDefinition, EventDefinition } from '../../../shared/interfaces/event.interfaces';

const basePath = '/event/definitions';

@Injectable({
  providedIn: 'root',
})
export class EventDefinitionsService {
  constructor(private http: HttpClient) { }

  // Gets event definitions of current and parent dealer
  getEventDefinitions(): Observable<EventDefinition[]> {
    return this.http.get<EventDefinition[]>(`${basePath}`);
  }

  // Creates a new event definition for the current dealer
  createEventDefinition(payload: CreateEventDefinition): Observable<EventDefinition> {
    const body = payload
    return this.http.post<EventDefinition>(`${basePath}`, body);
  }

  // Updates an existing event definition
  updateEventDefinition(payload: EventDefinition) {
    const body = payload
    return this.http.put(`${basePath}`, body);
  }

  // Gets details of a specific event definition
  getEventDefinitionById(definitionId: number): Observable<EventDefinition> {
    return this.http.get<EventDefinition>(`${basePath}/${definitionId}`);
  }

  // Deletes an event definition
  deleteEventDefinition(definitionId: number): Observable<EventDefinition> {
    return this.http.delete<EventDefinition>(`${basePath}/${definitionId}`);
  }

}
